import { useState } from 'react'

import { Popover, PopoverContent, PopoverTrigger } from 'components/ui/popover'

import { useUnreadNotifications } from '../hooks/useUnreadNotifications'
import { BellButton } from './BellButton'
import { NotificationList } from './NotificationList'

/**
 * The bell in the desktop header (MYD-542), beside Messages. The count is
 * polled; the list is a popover fetched when it opens.
 */
export function NotificationBell() {
	const unreadCount = useUnreadNotifications()
	const [open, setOpen] = useState(false)

	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger asChild>
				<BellButton unreadCount={unreadCount} open={open} aria-expanded={open} />
			</PopoverTrigger>
			<PopoverContent align="end" sideOffset={8} className="w-[min(380px,calc(100vw-1.5rem))] p-0">
				{/* Unmounted when closed, so each opening fetches afresh. */}
				{open && <NotificationList className="max-h-[min(480px,70vh)]" onNavigate={() => setOpen(false)} />}
			</PopoverContent>
		</Popover>
	)
}

export default NotificationBell
